import { API_BASE_URL } from '../config/env';

/**
 * Use same-origin /api for proxied images in dev (requires src/setupProxy.js).
 */
export const normalizeAdMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;

  const trimmed = url.trim();
  if (trimmed.startsWith('/api/')) return trimmed;

  try {
    const apiOrigin = new URL(API_BASE_URL).origin;
    if (trimmed.startsWith(`${apiOrigin}/api/`)) {
      return trimmed.slice(apiOrigin.length);
    }
  } catch {
    /* ignore */
  }

  if (/^https?:\/\/localhost:5000\/api\//i.test(trimmed)) {
    return trimmed.replace(/^https?:\/\/localhost:5000/i, '');
  }

  if (/^https?:\/\/127\.0\.0\.1:5000\/api\//i.test(trimmed)) {
    return trimmed.replace(/^https?:\/\/127\.0\.0\.1:5000/i, '');
  }

  return trimmed;
};
